import eventEditions from '../../eventEditions.json';
import { ReactSettings } from './Constants';
// setEnvVar logic copied from featureToggles.js
const setEnvVar = (env) => {
  if (env) {
    return env;
  }
  return 'prod';
};

const reactSettingsPriority = [
  ReactSettings.participantProfile,
  ReactSettings.participantDetails,
  ReactSettings.participantList,
  ReactSettings.participantDirectory,
  ReactSettings.featureFilters,
  ReactSettings.reactSettingsParticipantSettings,
  ReactSettings.default
];

const getWindowObject = () => global.window || (typeof window !== 'undefined' ? window : undefined);

const getEnvironmentFromWindow = (windowObject) => {
  const settings = reactSettingsPriority
    .map((settingKey) => windowObject[settingKey])
    .find((setting) => setting);

  return settings?.environment;
};

const getEnvironment = () => {
  const windowObject = getWindowObject();
  if (windowObject) {
    return getEnvironmentFromWindow(windowObject);
  }

  return global.process.env.environment;
};

/**
 * Checks if the given eventEditionId is present in any environment in eventEditions.json
 * @param {string} eventEditionId
 * @returns {boolean}
 */
export function isNewAlgoliaIndexEnabled(eventEditionId) {
  if (!eventEditionId) return false;
  // get current environment (same as featureToggles.js)
  let env = getEnvironment();
  env = setEnvVar(env);
  const arr = eventEditions[env];
  return Array.isArray(arr) && arr.includes(eventEditionId);
}
